/* eslint-disable no-param-reassign */

import { MutableRefObject } from 'react'

export const applyZoomTransition = (ref: MutableRefObject<any>, seconds = '0.3s') => {
  if (ref?.current) {
    ref.current.style.transition = `all ${seconds} ease  ${seconds}`
    ref.current.style.WebkitTransition = `all ${seconds} ease  ${seconds}`
    ref.current.style.MozTransition = `all ${seconds} ease  ${seconds}`
  }
}

export const applyTranslateTransistion = (ref) => {
  if (ref?.current) {
    ref.current.style.transition = 'unset'
  }
}
